import { SimpleSite } from 'api';

export const areCoordinatesSetOnSite = (site: SimpleSite): boolean => {
  if (!site.latitude || !site.longitude) {
    return false;
  }
  // We are checking for (0,0) because in case we have a bug on the backend and the coordinates are set incorrectly,
  // the most common value would be (0,0).
  if (site.latitude === '0' && site.longitude === '0') {
    return false;
  }
  return true;
};
